import React, { useEffect, useState } from 'react';
import PropTypes, { array } from 'prop-types';

// Material UI imports
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, Card, CardContent, Divider, Button, Box, OutlinedInput, MenuItem, FormControl, Select, Switch, useIsFocusVisible } from '@material-ui/core';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
// Component imports
import Feedback from '../../components/Feedback/Feedback';
import ProviderService from '../../services/ProviderService/ProviderService';
import ProductService from '../../services/ProductService/ProductService';
import RequiredFieldAlert from '../../components/RequiredFieldAlert/RequiredFieldAlert'
import { error } from 'ajv/dist/vocabularies/applicator/dependencies';



// Define component styles
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: '10px',
  },
  typography: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  card: {
    border: '1px solid #a52a2a',
    backgroundColor: '#fff',
  },
  subCard: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    padding: '8px'
  },
  EmpsubCard: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    marginBottom: '10px'
  },
  cardContent: {
    padding: '10px',
  },
  EmploymentcardContent: {
    border: '2px solid #d5d0d0',
    margin: '11px',
    borderRadius: '10px',
  },
  title: {
    fontSize: '14px',
    fontWeight: 'bold',
    backgroundColor: '#79232e',
    color: '#fff',
    padding: '8px',
    borderRadius: '4px',
    height: '30px',
    lineHeight: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    marginBottom: '14px',
    width: '100%',
  },
  subTitle: {
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#79232e'
  },
  property: {
    fontSize: '12px',
    fontWeight: 600,
    marginBottom: '5px',
  },
  inputTextbox: {
    padding: '0 10px',
    height: '31px',
    borderRadius: '20px',
    border: '1px solid #d5c8c8',
    width: '100%',
    fontSize: '12px',


  },
  activeInputinput: {
    padding: '0 10px',
    height: '31px',
    borderRadius: '20px',
    border: '1px solid #d5c8c8',
    width: '100%',
    fontSize: '12px',

    '&:active': {
      outline: '#2d8ecf',
      border: '2px solid #2d8ecf',
    },
    '&:focus': {
      outline: '#2d8ecf',
      border: '2px solid #2d8ecf',
    }

  },
  formControl: {
    width: '100%',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #d5c8c8',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #d5c8c8',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #d5c8c8',
    },
  },
  select: {
    height: '31px',
    borderRadius: '14px',
    width: '100%',
    backgroundColor: '#fff',
    fontSize: '12px',
    borderColor: '#5',
    '&.MuiSelect-select': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
    },
    '&.Mui-focused': {
      borderColor: '#d5c8c8 !important',
    },
    '& .MuiSelect-selectMenu': {
      backgroundColor: 'transparent',
    },
  },
  dropdownPlaceholder: {
    color: theme.palette.text.disabled,
    fontSize: '12px',
    fontStyle: 'normal',
    backgroundColor: '#fff',
  },
  outlinedInput: {
    fontSize: '12px',
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#79232e !important',
      borderWidth: '0px !important',
      backgroundColor: '#fff',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#79232e !important',
      borderWidth: '0px !important',
      backgroundColor: '#fff',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#79232e !important',
      borderWidth: '0px !important',
      backgroundColor: '#fff',
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      backgroundColor: '#fff',
    },


  },
  menuItem: {
    fontSize: '12px',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#a12e3d'
    },
    '&.Mui-selected': {
      color: '#fff',
      backgroundColor: '#79232e',
      '&:hover': {
        color: '#fff',
        backgroundColor: '#a12e3d'
      },
    },
  },
  value: {
    marginTop: 6,
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
  switch: {
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#79232e',
        },
      },
    }
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    fontSize: '14px',
    textTransform: 'capitalize',
    borderRadius: '100px',
    paddingLeft: '2rem',
    paddingRight: '2rem',
    backgroundColor: '#79232e',
    fontWeight: 700,
    color: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#a12e3d'
    },
    '&:active': {
      color: '#fff',
      backgroundColor: '#79232e'
    },
    '&:focus': {
      color: '#fff',
      backgroundColor: '#79232e'
    }
  },
  buttonBorrower: {
    marginTop: theme.spacing(3),
    fontSize: '12px',
    textTransform: 'capitalize',
    borderRadius: '100px',
    backgroundColor: '#79232e',
    fontWeight: 700,
    color: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#a12e3d'
    },
    '&:active': {
      color: '#fff',
      backgroundColor: '#79232e'
    },
    '&:focus': {
      color: '#fff',
      backgroundColor: '#79232e'
    }
  },
  VisuallyHiddenInput: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  },
  Filebutton: {
    width: '100%',
    background: 'transparent',
    boxShadow: 'none !important',
    border: '1px dashed #79232e',
    display: 'flex',
    justifyContent: 'flex-start',
    borderRadius: '50px',
    fontSize: '0.7vw !important',
    height: '32px',
  },
  selectedfilename: {
    color: "#000",
    fontWeight: "600",
    minWidth: '85%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    fontSize: ' 0.9vw',
  },


  TypographyFlex: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    height: '30px'
  },
  flexcontainer: {
    display: 'flex',
    flexDirection: 'column',

  },
  empGrid: {
    padding: "10px",
    border: '2px solid red',
  },
  Employmentheading: {
    textAlign: 'center',
    color: '#79232e',
  },

  require: {
    color: "red",
  },
  fileNameMain: {
    marginTop: "3px",
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: "3px",
  },
  fileNames: {
    width: "fit-content",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    background: "#f9f9f9",

  },


}));

// Component that displays
const BorrowerInformation = (props) => {

  const token = JSON.parse(localStorage.getItem('auth'));

  // Bind styling
  const classes = useStyles();
  const providerService = ProviderService();
  const productService = ProductService();
  const [loading, setLoading] = useState(true);
  const [verificationTypes, setVerificationTypes] = useState(['VOE', 'VOI']);
  const [providers, setProviders] = useState([]);
  const [products, setProducts] = useState([]);
  const [purpose, setPurpose] = useState(['PPCREDIT']);
  const [selectedVerificationType, setSelectedVerificationType] = useState("VOE");
  const [selectedProviders, setSelectedProviders] = useState('Waterfall');
  const [selectedProducts, setSelectedProducts] = useState('');
  const [selectedLoanPurposeType, setSelectedLoanPurposeType] = useState("PPCREDIT");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [borrowerDataArray, setBorrowerDataArray] = useState([]);
  const [selectedBorrowerType, setSelectedBorrowerType] = useState([]);
  const [selectedBorrowerTypes, setSelectedBorrowerTypes] = useState(null);
  const [selectedBorrowerIndex, setSelectedBorrowerIndex] = useState(null);
  const [fileName, setFileName] = useState([]);
  const [fileButtonName, setFileButtonName] = useState([]);
  const [BorrowerAuthorization, setBorrowerAuthorization] = useState([]);
  const [showRequiredAlert, setShowRequiredAlert] = useState(false);


  const [errors, setErrors] = useState({
    loanNumber: '',
    verificationType: '',
    provider: '',
    product: '',
    loanPurposeType: '',
    borrowerOptions: '',
    // borrowerAuthorization:'',
    borrowers: [],
  });
  const [requiredfielderrors, setRequiredFieldErrors] = useState({
    loanNumber: '',
    verificationType: '',
    provider: '',
    product: '',
    loanPurposeType: '',
  });
  const validateForm = () => {
    const loanNumber = props.loan?.loanNumber || '';


    let valid = true;
    let isCurrentBorrowerValid = true;
    // Reset error messages
    setErrors({
      loanNumber: '',
      verificationType: '',
      provider: '',
      product: '',
      loanPurposeType: '',
      borrowerOptions: '',
      // borrowerAuthorization:'',
      borrowers: [],
    });

    if (!selectedBorrowerTypes) {
      setErrors(prev => ({ ...prev, borrowerOptions: 'Borrower option is required.' }));
      valid = false;
    }

    // Validate loan number
    if (loanNumber.trim() === '') {
      setErrors(prev => ({ ...prev, loanNumber: 'Loan Number is required.' }));
      valid = false;
    }

    // Validate verificationType
    if (!selectedVerificationType) {
      setErrors(prev => ({ ...prev, verificationType: 'Verification Type is required.' }));
      valid = false;
    }

    // Validate provider
    if (!selectedProviders) {
      setErrors(prev => ({ ...prev, provider: 'Provider is required.' }));
      valid = false;
    }

    // Validate product if provider is not Waterfall
    if (selectedProviders !== 'Waterfall' && !selectedProducts) {
      setErrors(prev => ({ ...prev, product: 'Product is required.' }));
      valid = false;
    }

    // Validate loan purpose type
    if (!selectedLoanPurposeType) {
      setErrors(prev => ({ ...prev, loanPurposeType: 'Loan Purpose Type is required.' }));
      valid = false;
    }


    // Validate borrowers
    if (borrowerDataArray.length === 0) {
      setErrors(prev => ({ ...prev, borrowers: ['At least one borrower is required.'] }));
      valid = false;
    } else {
      let borrowerErrors = [];

      const borrowersToValidate =selectedBorrowerIndex === null? borrowerDataArray.map((borrower, index) => ({ borrower, index }))     : [{ borrower: borrowerDataArray[selectedBorrowerIndex], index: selectedBorrowerIndex }];

      borrowersToValidate.forEach(({borrower, index}) => {
        let errorMessage = { };

        // if (!fileName[index] || fileName[index].length == 0) {
        //   errorMessage.borrowerAuthorization = "Borrower authorization is required";
        //   valid = false;
        // }

        // File upload validation
        const filesForBorrower = BorrowerAuthorization[index] || [];

        if (filesForBorrower.length > 0) {
          // Loop through files aur check karo

          const allowedExtensions = [
            "jpg", "jpeg", "png", "gif", "pdf",
            "doc", "docx",
            "xls", "xlsx",
            "csv",
            "txt"
          ];
          filesForBorrower.forEach(file => {
            const parts = file.name.split(".");
            if (parts.length !== 2) {
              errorMessage.borrowerAuthorization = "Invalid file name (double extension not allowed).";
              valid = false;
            } else {
              const ext = parts[1].toLowerCase();
              if (!allowedExtensions.includes(ext)) {
                errorMessage.borrowerAuthorization = `Invalid file type for ${file.name}. Allowed types: ${allowedExtensions.join(", ")}`;
                valid = false;
              }
            }
          });
        }

        if (!borrower.firstName || borrower.firstName.trim() === '') {
          errorMessage.firstName = 'First Name is required.';
          valid = false;
        }
        
        if (!borrower.lastName || borrower.lastName.trim() === '') {
          errorMessage.lastName = 'Last Name is required.';
          valid = false;
        }

        if (!borrower.ssn || borrower.ssn.trim() === '') {
          errorMessage.ssn = 'SSN  is required.';
          valid = false;
        }

        // if ((selectedVerificationType === 'VOE' && (selectedProviders === 'ARGYLE' || selectedProviders === 'TRUV'))
        //   || (selectedVerificationType === 'VOI' && (selectedProviders === 'ARGYLE' || selectedProviders === 'FINICITY'))) {

        if (!borrower.emailAddressText || borrower.emailAddressText.trim() === '') {
          errorMessage.emailAddressText = 'Email is required.';
          valid = false;
        }

        if (!borrower.homePhoneNumber || borrower.homePhoneNumber.trim() === '') {
          errorMessage.homePhoneNumber = 'Phone Nmber is required.';
          valid = false;
        }
        // }

        // ---------recidences---------------

        // if ((selectedVerificationType === 'VOE' && selectedProviders === 'EXPERIAN')
        //   || (selectedVerificationType === 'VOI' && (selectedProviders === 'EXPERIAN' || selectedProviders === 'FINICITY'))) {

        if (!borrower.birthDate || borrower.birthDate.trim() === '') {
          errorMessage.birthDate = 'Date of birth is required.';
          valid = false;
        }

        if (!borrower.residences?.streetName1 || borrower.residences?.streetName1.trim() === '') {
          errorMessage.streetName1 = 'Street name is required';
          valid = false;
        }

        // if (!borrower.residences?.streetAddress2 || borrower.residences?.streetAddress2.trim() === '') {
        //   errorMessage.streetAddress2 = 'Address line 2 is required.';
        //   valid = false;
        // }

        if (!borrower.residences?.city || borrower.residences?.city.trim() === '') {
          errorMessage.city = 'City is required.';
          valid = false;
        }

        if (!borrower.residences?.postalCode || borrower.residences?.postalCode.trim() === '') {
          errorMessage.postalCode = 'Zip code is required.';
          valid = false;
        }

        if (!borrower.residences?.state || borrower.residences?.state.trim() === '') {
          errorMessage.state = 'State is required.';
          valid = false;
        }
        //}


        // ---------------employment-------------------

        if (borrower.employerRequired) {
          borrower.employment.forEach((employment, empIndex) => {
            // if ((selectedVerificationType === 'VOE' && (selectedProviders === 'TRELIX' || selectedProviders === 'TRUV'))
            //   || (selectedVerificationType === 'VOI' && selectedProviders === 'TRELIX')) {



            if (!employment.employerName || employment.employerName.trim() === '') {
              errorMessage.employerName = 'Employee name is required';
              valid = false;
            }

            if (!employment.streetAddress || employment.streetAddress.trim() === '') {
              errorMessage.streetAddress = 'Street name is required';
              valid = false;
            }

            if (!employment.addressCity || employment.addressCity.trim() === '') {
              errorMessage.addressCity = 'City is required';
              valid = false;
            }

            if (!employment.addressState || employment.addressState.trim() === '') {
              errorMessage.addressState = 'State is required';
              valid = false;
            }

            if (!employment.addressPostalCode || employment.addressPostalCode.trim() === '') {
              errorMessage.addressPostalCode = 'Zip code is required';
              valid = false;
            }



            // if (!borrower.employment?.currentEmploymentIndicator || borrower.employment?.currentEmploymentIndicator.trim() === '') {
            //   errorMessage.currentEmploymentIndicator = 'Current Employer is required';
            //   valid = false;
            // }
            // }

            // if ((selectedVerificationType === 'VOE' && selectedProviders === 'TRELIX')
            //   || (selectedVerificationType === 'VOI' && selectedProviders === 'TRELIX')) {

            if (!employment.phoneNumber || employment.phoneNumber.trim() === '') {
              errorMessage.phoneNumber = 'Phone number is required';
              valid = false;
            }

            if (!employment.employmentStartDate || employment.employmentStartDate.trim() === '') {
              errorMessage.employmentStartDate = 'Start date  is required';
              valid = false;
            }

            if (!employment.currentEmploymentIndicator && (!employment.endDate || employment.endDate.trim() === '')) {
              errorMessage.endDate = 'End date is required';
              valid = false;
            }
            // }

            if (!employment.badgeOrEmployeeId || employment.badgeOrEmployeeId.trim() === '') {

              errorMessage.badgeOrEmployeeId = 'Employee Id is required';
              valid = false;
            }

            if (!employment.positionDescription || employment.positionDescription.trim() === '') {
              errorMessage.positionDescription = 'Job position is required';
              valid = false;
            }
          })
        }
        // if (!borrower.employment[index]?.basePayAmount || borrower.employment[index]?.basePayAmount.trim() === '') {
        //   errorMessage.basePayAmount = 'basePayAmount code is required';
        //   valid = false;
        // }

        if (errorMessage && Object.keys(errorMessage).length > 0) {
          borrowerErrors[index] = errorMessage;

          // if (selectedBorrowerIndex === null || selectedBorrowerIndex === index) {
          //   isCurrentBorrowerValid = false;
          // }
          isCurrentBorrowerValid = false;
          // If validating all, set valid false
          if (selectedBorrowerIndex === null) {
            valid = false;
          }

        }
      });
      setErrors(prev => ({ ...prev, borrowers: borrowerErrors }));
    }

    return selectedBorrowerIndex === null ? valid : (valid && isCurrentBorrowerValid);
    // return valid;
  };
  const RequiredFieldValidation = () => {
    const loanNumber = props.loan?.loanNumber || '';


    let valid = true;
    let isCurrentBorrowerValid = true;
    // Reset error messages
    setRequiredFieldErrors({
      loanNumber: '',
      verificationType: '',
      provider: '',
      product: '',
      loanPurposeType: '',

    });



    // Validate loan number
    if (loanNumber.trim() === '') {
      setRequiredFieldErrors(prev => ({ ...prev, loanNumber: 'Loan Number (364)' }));
      valid = false;
    }

    // Validate verificationType
    if (!selectedVerificationType) {
      setRequiredFieldErrors(prev => ({ ...prev, verificationType: 'Verification Type is required.' }));
      valid = false;
    }

    // Validate provider
    if (!selectedProviders) {
      setRequiredFieldErrors(prev => ({ ...prev, provider: 'Provider is required.' }));
      valid = false;
    }

    // Validate product if provider is not Waterfall
    if (selectedProviders !== 'Waterfall' && !selectedProducts) {
      setRequiredFieldErrors(prev => ({ ...prev, product: 'Product is required.' }));
      valid = false;
    }

    // Validate loan purpose type
    if (!selectedLoanPurposeType) {
      setRequiredFieldErrors(prev => ({ ...prev, loanPurposeType: 'Loan Purpose (19)' }));
      valid = false;
    }

    return valid;
    // return valid;
  };
  const initialBorrowerAdd = () => {
    const applications = props.loan?.applications || [];

    if (applications.length > 0 && borrowerDataArray.length < 8) {
      const newBorrowers = applications.map((app) => {
        const employmentData = app?.employment || [];

        const employment_temp_array = employmentData.map(emp => ({
          id: emp?.id || "",
          employerCode: "",
          employerDivision: "",
          employerName: emp?.employerName || "",
          addressCity: emp?.addressCity || "",
          addressPostalCode: emp?.addressPostalCode || "",
          addressState: emp?.addressState || "",
          badgeOrEmployeeId: emp?.badgeOrEmployeeId || "",
          basePayAmount: emp?.basePayAmount || "",
          currentEmploymentIndicator: emp?.currentEmploymentIndicator || "",
          employmentStartDate: emp?.employmentStartDate || "",
          endDate: emp?.endDate || "",
          phoneNumber: emp?.phoneNumber || "",
          positionDescription: emp?.positionDescription || "",
          streetAddress: emp?.urla2020StreetAddress || "",
        }));

        return {

          id: app?.id || "",
          firstName: app?.firstName || "",
          lastName: app?.lastName || "",
          borrowerOptions: app?.borrowerOptions || "",
          birthDate: app?.birthDate || "",
          emailAddressText: app?.emailAddressText || "",
          fullNameWithSuffix: app?.fullNameWithSuffix || "",
          homePhoneNumber: app?.homePhoneNumber || "",
          middleName: app?.middleName || "",
          ssn: app?.taxIdentificationIdentifier || "",
          employment: employment_temp_array,
          residences: {
            city: app?.residences?.[0]?.addressCity || "",
            postalCode: app?.residences?.[0]?.addressPostalCode || "",
            state: app?.residences?.[0]?.addressState || "",
            streetName1: app?.residences?.[0]?.addressStreetLine1 ?? app?.residences?.[0]?.urla2020StreetAddress ?? "",
            streetAddress2: "",
          },
          isPrimary: false,
          salaryKey: '',
          employerRequired: employment_temp_array.length > 0 ? true : false
        };
      });

      // Ab set karo pura array (previous + new)
      setBorrowerDataArray(prev => [...prev, ...newBorrowers]);
    }
  };


  const fetchProviders = async (verificationType) => {
    setLoading(true);
    try {
      const data = await providerService.getProvider(verificationType, token.token);
      setProviders(data || []);
    } catch (error) {
      console.error("Failed to fetch providers:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async (verificationType, provider) => {
    setLoading(true);
    try {
      const data = await productService.getProduct(verificationType, provider, token.token)
      setProducts(data || []);
    } catch (error) {
      console.error("Failed to fetch products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let list = [];

    if (borrowerDataArray.length > 0) {
      list.push("All Borrowers");

      borrowerDataArray.forEach((item, index) => {

        list.push(item.borrowerOptions);
      });
    }
    setSelectedBorrowerType(list);
  }, [borrowerDataArray]);

  const handleChangeSelect = (event, type) => {
    const value = event.target.value;

    if (type === 'verificationType') {

      setSelectedVerificationType(value);
      fetchProviders(value);
      setSelectedProviders('Waterfall');
      setSelectedProducts('');
    }
    else if (type === 'provider') {
      setSelectedProviders(value);
      setSelectedProducts('');
      // If the provider is 'Waterfall', reset selectedProducts to empty, since no product is required.
      if (value != 'Waterfall') {
        setSelectedProducts('');
        fetchProducts(selectedVerificationType, value);
      }
    } else if (type === 'product') {
      setSelectedProducts(value);
    }
    else if (type === 'loanPurposeType') {
      setSelectedLoanPurposeType(value);
    } else if (type === "selectborrower") {
      // setBorrowerAuthorization([]);
      // setFileName([]);

      setSelectedBorrowerTypes(value);
      if (value === "All Borrowers") {

        setSelectedBorrowerIndex(null); // Show all
        if (borrowerDataArray && borrowerDataArray.length > 0) {
          const updatedArray = borrowerDataArray.map((borrower, i) => ({
            ...borrower,
            isPrimary: i === 0 ? true : false, // sirf 0 index pe true, sab pe false
          }));
          setBorrowerDataArray(updatedArray);
        }

      } else {

        const index = selectedBorrowerType.indexOf(value);
        setSelectedBorrowerIndex(index - 1);
        if (borrowerDataArray && borrowerDataArray.length > 0) {
          const updatedArray = borrowerDataArray.map((borrower, i) => ({
            ...borrower,
            isPrimary: i === index - 1 ? true : false,
          }));

          setBorrowerDataArray(updatedArray);
        }
      }
      // setErrors(prev => ({ ...prev, borrowerOptions: '' }));
      setErrors({
        loanNumber: '',
        verificationType: '',
        provider: '',
        product: '',
        loanPurposeType: '',
        borrowerOptions: '',
        borrowers: [],
      });
    }
  };



  const handleChangeSwitch = (event, index, field) => {
    const value = event.target.checked;

    if (field === "isPrimary") {
      setBorrowerDataArray(prevBorrowers => {
        const updatedBorrowers = prevBorrowers.map((borrower, i) => ({
          ...borrower,


          isPrimary: selectedBorrowerIndex != null ? i === selectedBorrowerIndex : i === index ? value : false,

        }));

        const hasPrimary = updatedBorrowers.some(b => b.isPrimary);
        if (!hasPrimary) {
          updatedBorrowers[0].isPrimary = true;
        }

        return updatedBorrowers;
      });
    }
    else {
      setBorrowerDataArray(prevArray => {
        const updatedArray = [...prevArray];
        const employmentArray = updatedArray[index]?.employment || [];
        if (employmentArray.length > 0 && updatedArray[index]) {
          updatedArray[index] = {
            ...updatedArray[index],
            [field]: value
          };
        }

        return updatedArray;
      });
    }
  };





  const handleBlurUpdate = (event, index, employmentIndex, field) => {
    const value = event.target.value.trim();

    if (field === "employerCode" || field === "employerDivision") {
      setBorrowerDataArray(prevArray => {
        const updatedArray = [...prevArray];
        if (updatedArray[index]?.employment?.[employmentIndex]) {
          updatedArray[index].employment[employmentIndex] = {
            ...updatedArray[index].employment[employmentIndex],
            [field]: value
          };
        }
        return updatedArray;
      });
    }
    else {
      setBorrowerDataArray(prevArray => {
        const updatedArray = [...prevArray];
        if (updatedArray[index]) {
          updatedArray[index] = {
            ...updatedArray[index],
            [field]: value
          };
        }
        return updatedArray;
      });
    }
  };
  // const handleFileChange = async (event, index) => {
  //   const file = event.target.value;

  //   const host = await props.host;
  //   let userSelectedResources;

  //   try {
  //     userSelectedResources = await host.performActionObject(); 
  //   } catch (error) {
  //     console.log({ error });
  //     return; 
  //   }

  //   if (userSelectedResources && userSelectedResources.length > 0) {
  //     const userSelectedFiles = [...BorrowerAuthorization];
  //     const existingFiles = userSelectedFiles[index] || [];

  //     const newUniqueResources = userSelectedResources.filter(newFile =>
  //       !existingFiles.some(existingFile =>
  //         existingFile.name === newFile.name && existingFile.size === newFile.size
  //       )
  //     );

  //     userSelectedFiles[index] = [...existingFiles, ...newUniqueResources];
  //     setBorrowerAuthorization(userSelectedFiles);

  //     const updatedFileNames = [...fileName];
  //     const existingNames = updatedFileNames[index] || [];
  //     updatedFileNames[index] = [...existingNames, ...newUniqueResources.map(res => res.name)];
  //     setFileName(updatedFileNames);

  //     const updatedButtonNames = [...fileButtonName];
  //     updatedButtonNames[index] = "Upload file";
  //     setFileButtonName(updatedButtonNames);
  //   }
  // };


  const allowedExtensions = [
    "jpg", "jpeg", "png", "gif", "pdf",
    "doc", "docx",
    "xls", "xlsx",
    "csv",
    "txt"
  ];

  const handleFileChange = async (event, index) => {
    const host = await props.host;
    let userSelectedResources;

    try {
      // Encompass uploader open karna
      userSelectedResources = await host.performActionObject();
    } catch (error) {
      console.log({ error });
      return;
    }

    if (!userSelectedResources || userSelectedResources.length === 0) return;

    const userSelectedFiles = [...BorrowerAuthorization];
    const existingFiles = userSelectedFiles[index] || [];

    // Temporary array to collect error messages for this selection
    let errorMessages = [];

    // Filter and validate files
    const newUniqueResources = userSelectedResources.filter(newFile => {
      const fileNameParts = newFile.name.split(".");
      const hasSingleExtension = fileNameParts.length === 2;
      const extension = fileNameParts[1]?.toLowerCase();
      const isAllowedExtension = allowedExtensions.includes(extension);

      // Invalid file
      if (!hasSingleExtension || !isAllowedExtension) {
        errorMessages.push(
          `Invalid file: ${newFile.name}. Only single extension allowed and types: ${allowedExtensions.join(", ")}`
        );
        return false; // ignore invalid file
      }

      // Already exists check
      const isUnique = !existingFiles.some(
        existingFile => existingFile.name === newFile.name && existingFile.size === newFile.size
      );

      if (!isUnique) {
        errorMessages.push(`File already uploaded: ${newFile.name}`);
      }

      return isUnique;
    });

    // ✅ Update error state for all invalid files
    setErrors(prev => {
      const updated = [...(prev.borrowers || [])];
      updated[index] = { ...updated[index], borrowerAuthorization: errorMessages.join(", ") };
      return { ...prev, borrowers: updated };
    });

    if (newUniqueResources.length === 0) return;

    // ✅ Add valid files
    userSelectedFiles[index] = [...existingFiles, ...newUniqueResources];
    setBorrowerAuthorization(userSelectedFiles);

    const updatedFileNames = [...fileName];
    const existingNames = updatedFileNames[index] || [];
    updatedFileNames[index] = [...existingNames, ...newUniqueResources.map(res => res.name)];
    setFileName(updatedFileNames);

    const updatedButtonNames = [...fileButtonName];
    updatedButtonNames[index] = "Upload file";
    setFileButtonName(updatedButtonNames);

    // ✅ Remove error messages for valid files only
    if (newUniqueResources.length > 0) {
      setErrors(prev => {
        const updated = [...(prev.borrowers || [])];
        if (updated[index]) {
          // Keep only remaining error messages for invalid files
          const remainingErrors = errorMessages.filter(err =>
            !newUniqueResources.some(f => err.includes(f.name))
          );
          updated[index].borrowerAuthorization = remainingErrors.join(", ") || undefined;
        }
        return { ...prev, borrowers: updated };
      });
    }
  };

  // const handleFileChange = async (event, index) => {
  //   const host = await props.host;
  //   let userSelectedResources;

  //   try {
  //     // ✅ Encompass uploader open karna
  //     userSelectedResources = await host.performActionObject();
  //   } catch (error) {
  //     console.log({ error });
  //     return;
  //   }

  //   if (!userSelectedResources || userSelectedResources.length === 0) return;

  //   const userSelectedFiles = [...BorrowerAuthorization];
  //   const existingFiles = userSelectedFiles[index] || [];

  //   // ✅ Validation lagana: double extension + whitelist
  //   const newUniqueResources = userSelectedResources.filter(newFile => {
  //     const fileNameParts = newFile.name.split(".");
  //     const hasSingleExtension = fileNameParts.length === 2;

  //     const extension = fileNameParts[1]?.toLowerCase();
  //     const isAllowedExtension = allowedExtensions.includes(extension);

  //     if (!hasSingleExtension || !isAllowedExtension) {
  //       const errorMessage = `Invalid file: ${newFile.name}. Only single extension allowed and types: ${allowedExtensions.join(", ")}`;

  //       // ✅ Error state update
  //       setErrors(prev => {
  //         const updated = [...(prev.borrowers || [])];
  //         updated[index] = { ...updated[index], borrowerAuthorization: errorMessage };
  //         return { ...prev, borrowers: updated };
  //       });


  //       return false; // invalid file ignore
  //     }

  //     // ✅ Already existing file check
  //     const isUnique = !existingFiles.some(
  //       existingFile => existingFile.name === newFile.name && existingFile.size === newFile.size
  //     );

  //     return isUnique;
  //   });

  //   if (newUniqueResources.length === 0) return;

  //   // ✅ State update for valid files
  //   userSelectedFiles[index] = [...existingFiles, ...newUniqueResources];
  //   setBorrowerAuthorization(userSelectedFiles);

  //   const updatedFileNames = [...fileName];
  //   const existingNames = updatedFileNames[index] || [];
  //   updatedFileNames[index] = [...existingNames, ...newUniqueResources.map(res => res.name)];
  //   setFileName(updatedFileNames);

  //   const updatedButtonNames = [...fileButtonName];
  //   updatedButtonNames[index] = "Upload file";
  //   setFileButtonName(updatedButtonNames);

  //   // ✅ Clear previous error if file is valid
  //   setErrors(prev => {
  //     const updated = [...(prev.borrowers || [])];
  //     if (updated[index]) {
  //       delete updated[index].borrowerAuthorization;
  //     }
  //     return { ...prev, borrowers: updated };
  //   });
  // };

  // const handleFileChange = async (event, index) => {
  //   const host = await props.host;
  //   let userSelectedResources;

  //   try {
  //     // ✅ Encompass uploader open karna
  //     userSelectedResources = await host.performActionObject(); 
  //   } catch (error) {
  //     console.log({ error });
  //     return; 
  //   }

  //   if (!userSelectedResources || userSelectedResources.length === 0) return;

  //   const userSelectedFiles = [...BorrowerAuthorization];
  //   const existingFiles = userSelectedFiles[index] || [];

  //   // ✅ Validation lagana: double extension + whitelist
  //   const newUniqueResources = userSelectedResources.filter(newFile => {
  //     // Double extension check
  //     const fileNameParts = newFile.name.split(".");
  //     const hasSingleExtension = fileNameParts.length === 2;

  //     // Extension whitelist check
  //     const extension = fileNameParts[1]?.toLowerCase();
  //     const isAllowedExtension = allowedExtensions.includes(extension);

  //     if (!hasSingleExtension || !isAllowedExtension) {
  //       alert(`Invalid file: ${newFile.name}. Only single extension allowed and types: ${allowedExtensions.join(", ")}`);
  //       return false; // invalid files ignore karo
  //     }

  //     // Already existing file check
  //     const isUnique = !existingFiles.some(
  //       existingFile => existingFile.name === newFile.name && existingFile.size === newFile.size
  //     );

  //     return isUnique;
  //   });

  //   if (newUniqueResources.length === 0) return;

  //   // ✅ State update (borrower authorization)
  //   userSelectedFiles[index] = [...existingFiles, ...newUniqueResources];
  //   setBorrowerAuthorization(userSelectedFiles);

  //   const updatedFileNames = [...fileName];
  //   const existingNames = updatedFileNames[index] || [];
  //   updatedFileNames[index] = [...existingNames, ...newUniqueResources.map(res => res.name)];
  //   setFileName(updatedFileNames);

  //   const updatedButtonNames = [...fileButtonName];
  //   updatedButtonNames[index] = "Upload file";
  //   setFileButtonName(updatedButtonNames);
  // };

  const handleCancelFile = (event, borrowerIndex, fileIndex) => {
    event.preventDefault();

    const updatedFileNames = [...fileName];
    if (Array.isArray(updatedFileNames[borrowerIndex])) {
      updatedFileNames[borrowerIndex].splice(fileIndex, 1);
    }
    setFileName(updatedFileNames);

    const updatedBorrowerAuthorization = [...BorrowerAuthorization];
    if (updatedBorrowerAuthorization[borrowerIndex]) {
      updatedBorrowerAuthorization[borrowerIndex].splice(fileIndex, 1);
    }
    setBorrowerAuthorization(updatedBorrowerAuthorization);
  };


  useEffect(() => {
    const isValid = RequiredFieldValidation();
    setShowRequiredAlert(!isValid);
  }, [borrowerDataArray]);

  useEffect(() => {
    if (props.loan) {
      fetchProviders(selectedVerificationType);
      initialBorrowerAdd();

    }

    // eslint-disable-next-line
  }, [props.loan]);

  const handleBorrowerData = () => {
    let AuthorizationDoc;
    const selectedBorrowers =
      selectedBorrowerIndex !== null
        ? [borrowerDataArray[selectedBorrowerIndex]]
        : borrowerDataArray;

    const borrowerData = {
      // verificationType: selectedVerificationType,
      // provider: selectedProviders,
      // productName: selectedProducts,
      // loanPurposeType: selectedLoanPurposeType,
      borrower: selectedBorrowers.map((borrower, index) => ({
        id: borrower.id,
        isPrimary: borrower.isPrimary,
        salaryKey: borrower.salaryKey,
        employerRequired: borrower.employerRequired,
        resources: Array.isArray(BorrowerAuthorization[selectedBorrowerIndex ?? index])
          ? BorrowerAuthorization[selectedBorrowerIndex ?? index].map(res => ({
            id: res.id || '',
            name: res.name || '',
            mimeType: res.mimeType || '',
            source: res.source || '',
            documentFolder: res.documentFolder || '',
          }))
          : [],
        employment: borrower.employerRequired ? borrower.employment.map(emp => ({
          id: emp.id,
          employerCode: emp.employerCode,
          employerDivision: emp.employerDivision
        })) : null
      }))
    };

    if (
      selectedBorrowerIndex != null &&
      Array.isArray(BorrowerAuthorization) &&
      Array.isArray(BorrowerAuthorization[selectedBorrowerIndex])
    ) {
      AuthorizationDoc = [...BorrowerAuthorization[selectedBorrowerIndex]];
    }
    const finalAuthorization =
      AuthorizationDoc != null
        ? AuthorizationDoc
        : (BorrowerAuthorization.length > 0 ? BorrowerAuthorization : null);

    // props.onProviderData(borrowerData, finalAuthorization );
    props.onProviderData(borrowerData, finalAuthorization, selectedVerificationType, selectedProviders, selectedProducts, selectedLoanPurposeType);

  };



  const handleNext = async () => {

    const isValid = validateForm();
    if (isValid) {
      handleBorrowerData();
      props.onNext();

    }
  };
  const LoadingContainer = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', position: 'absolute', left: 0, bottom: 0, zIndex: 9999 }}>
        <Feedback message='Loading...' />
      </div>
    );
  };

  // Initialized component bound to state data
  const InitializedBorrowerInformation = (props) => {
    return (
      <React.Fragment>
        {showRequiredAlert && (
          <RequiredFieldAlert requiredfielderrors={requiredfielderrors} host={props.host} />
        )}
        <div className={classes.root} style={{ width: '85%', margin: "0 auto" }}>
          <Typography component='h3' variant='h4' align='left' className={classes.typography}>
            VERIFICATION OF EMPLOYMENT/INCOME (VOE/VOI)
          </Typography>
          <Card className={classes.card}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Card className={classes.subCard}>
                  <CardContent className={classes.cardContent}>
                    <Typography variant="h6" className={classes.title}>
                      Loan Information
                    </Typography>
                    <Grid container spacing={2} style={{ position: 'relative' }} >
                      {loading && (
                        <LoadingContainer />
                      )}
                      <Grid item xs={12}>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Typography variant="body2" className={classes.property}>Verification Type </Typography>
                            <Typography className={classes.value}>
                              <FormControl className={classes.formControl}>
                                <Select
                                  multiple={false}
                                  displayEmpty
                                  value={selectedVerificationType}
                                  onChange={(event) => handleChangeSelect(event, 'verificationType')}
                                  input={<OutlinedInput className={classes.outlinedInput} autoComplete="off" />}
                                  renderValue={(selected) => {
                                    if (!selected || selected.length === 0) {
                                      return <span className={classes.dropdownPlaceholder}><em style={{ fontStyle: 'normal' }}>Select verificationType...</em></span>;
                                    }
                                    return selected;
                                  }}
                                  className={classes.select}>
                                  {verificationTypes.map((verificationType) => (
                                    <MenuItem key={verificationType} value={verificationType} className={classes.menuItem}>
                                      {verificationType}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography variant="body2" className={classes.property}>Provider </Typography>
                            <Typography className={classes.value}>

                              <FormControl className={classes.formControl}>
                                <Select
                                  multiple={false}
                                  displayEmpty
                                  value={selectedProviders}
                                  onChange={(event) => handleChangeSelect(event, 'provider')}
                                  input={<OutlinedInput className={classes.outlinedInput} autoComplete="off" />}
                                  renderValue={(selected) => {
                                    if (!selected || selected.length === 0) {
                                      return <span className={classes.dropdownPlaceholder}><em style={{ fontStyle: 'normal' }}>Select provider...</em></span>;
                                    }
                                    return selected;
                                  }}
                                  className={classes.select}>
                                  {providers.map((provider) => (
                                    <MenuItem key={provider} value={provider} className={classes.menuItem}>
                                      {provider}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              {errors.provider && (
                                <Typography variant="body2" color="error" className={classes.errorMessage}>
                                  {errors.provider}
                                </Typography>
                              )}
                            </Typography>
                          </Grid>
                          {selectedProviders !== 'Waterfall' && (
                            <Grid item xs={4}>
                              <Typography variant="body2" className={classes.property}>Product </Typography>
                              <Typography className={classes.value}>
                                <FormControl className={classes.formControl}>
                                  <Select
                                    multiple={false}
                                    displayEmpty
                                    value={selectedProducts}
                                    onChange={(event) => handleChangeSelect(event, 'product')}
                                    input={<OutlinedInput className={classes.outlinedInput} autoComplete="off" />}
                                    renderValue={(selected) => {
                                      if (!selected || selected.length === 0) {
                                        return <span className={classes.dropdownPlaceholder}><em style={{ fontStyle: 'normal' }}>Select product...</em></span>;
                                      }
                                      return selected;
                                    }}
                                    className={classes.select}>
                                    {products.map((product) => (
                                      <MenuItem key={product} value={product} className={classes.menuItem}>
                                        {product}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                {errors.product && (
                                  <Typography variant="body2" color="error" className={classes.errorMessage}>
                                    {errors.product}
                                  </Typography>
                                )}
                              </Typography>
                            </Grid>
                          )}
                          <Grid item xs={4}>
                            <Typography variant="body2" className={classes.property}>Loan </Typography>
                            <Typography className={classes.value}>
                              <input type="text" value={props.loan?.loanNumber} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                            </Typography>
                            {errors.loanNumber && (
                              <Typography variant="body2" color="error" className={classes.errorMessage}>
                                {errors.loanNumber}
                              </Typography>
                            )}
                          </Grid>


                          <Grid item xs={4}>
                            <Typography variant="body2" className={classes.property}>Purpose </Typography>
                            <Typography className={classes.value}>
                              <FormControl className={classes.formControl}>
                                <Select
                                  multiple={false}
                                  displayEmpty
                                  value={selectedLoanPurposeType}
                                  onChange={(event) => handleChangeSelect(event, 'loanPurposeType')}
                                  input={<OutlinedInput className={classes.outlinedInput} autoComplete="off" />}
                                  renderValue={(selected) => {
                                    if (!selected || selected.length === 0) {
                                      return <span className={classes.dropdownPlaceholder}><em style={{ fontStyle: 'normal' }}>Select Purpose...</em></span>;
                                    }
                                    return selected;
                                  }}
                                  className={classes.select}>
                                  {purpose.map((purpose) => (
                                    <MenuItem key={purpose} value={purpose} className={classes.menuItem}>
                                      {purpose}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Typography>
                            {errors.loanPurposeType && (
                              <Typography variant="body2" color="error" className={classes.errorMessage}>
                                {errors.loanPurposeType}
                              </Typography>
                            )}

                          </Grid>

                          <Grid item xs={4}>
                            <Typography variant="body2" className={classes.property}>Borrower</Typography>
                            <Typography className={classes.value}>
                              <FormControl className={classes.formControl}>
                                <Select
                                  multiple={false}
                                  displayEmpty
                                  value={selectedBorrowerTypes}
                                  onChange={(event) => handleChangeSelect(event, 'selectborrower')}
                                  input={<OutlinedInput className={classes.outlinedInput} autoComplete="off" />}
                                  renderValue={(selected) => {
                                    if (!selected || selected.length === 0) {
                                      return <span className={classes.dropdownPlaceholder}><em style={{ fontStyle: 'normal' }}>Select Borrower...</em></span>;
                                    }
                                    return selected;
                                  }}
                                  className={classes.select}>
                                  {selectedBorrowerType.map((selectborrowers) => (
                                    <MenuItem key={selectborrowers} value={selectborrowers} className={classes.menuItem}>
                                      {selectborrowers}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {errors.borrowerOptions && (
                                  <Typography variant="body2" color="error" className={classes.errorMessage}>
                                    {errors.borrowerOptions}
                                  </Typography>
                                )}
                              </FormControl>

                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Divider style={{ marginLeft: '16px', marginRight: '16px' }} />
              </Grid>

              {/* Borrower Information */}
              <Grid item xs={12}>
                <Card className={classes.subCard}>
                  <CardContent className={classes.cardContent}>

                    {selectedBorrowerTypes != null && borrowerDataArray.filter((_, index) =>
                      selectedBorrowerIndex === null ? true : index === selectedBorrowerIndex
                    ).map((borrower, index) => (

                      <Grid container spacing={2} key={index} className="borrower-container" >
                        <Typography variant="h6" className={classes.title}>
                          Borrower
                        </Typography>
                        <Grid item xs={12}>
                          <Typography variant="body2" className={classes.property}>Primary Borrower </Typography>
                          <Typography className={classes.value}>
                            {'No'}
                            <Switch
                              checked={borrower.isPrimary}
                              onChange={(event) => handleChangeSwitch(event, index, 'isPrimary')}
                              inputProps={{ 'aria-label': 'controlled' }}
                              className={classes.switch}
                            />
                            {'Yes'}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>First Name <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="text" value={borrower?.firstName || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {errors?.borrowers?.[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.firstName && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers?.[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.firstName}
                            </Typography>
                          )}
                        </Grid>

                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>Middle Name </Typography>
                          <Typography className={classes.value}>
                            <input type="text" value={borrower?.middleName || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {/* {errors?.borrowers[index]?.middleName && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[index].middleName}
                            </Typography>
                          )} */}
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>Last Name <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="text" value={borrower?.lastName || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.lastName && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].lastName}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>SSN <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="text" value={borrower?.ssn || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.ssn && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].ssn}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>Email <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="email" value={borrower?.emailAddressText || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.emailAddressText && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].emailAddressText}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>Phone <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="tel" value={borrower?.homePhoneNumber || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.homePhoneNumber && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].homePhoneNumber}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>Date of Birth <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="date" value={borrower?.birthDate || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.birthDate && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].birthDate}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>City <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="text" value={borrower?.residences?.city || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.city && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].city}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>State <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="text" value={borrower?.residences?.state || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.state && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].state}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2" className={classes.property}>Street Name <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="text" value={borrower?.residences?.streetName1 || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>

                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.streetName1 && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].streetName1}

                            </Typography>

                          )}

                        </Grid>

                        <Grid item xs={6}>
                          <Typography variant="body2" className={classes.property}>Address 2</Typography>
                          <Typography className={classes.value}>
                            <input type="text" value={borrower?.residences?.streetAddress2 || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {/* {errors?.borrowers[index]?.streetAddress2 && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[index].streetAddress2}
                            </Typography>
                          )} */}
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="body2" className={classes.property}>Zip <span className={classes.require} >*</span></Typography>
                          <Typography className={classes.value}>
                            <input type="text" value={borrower?.residences?.postalCode || ''} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                          </Typography>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.postalCode && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].postalCode}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={4} >
                          <Typography variant="body2" className={classes.property}>Salary Key</Typography>
                          <Typography className={classes.value}>
                            <input type="text" defaultValue={borrower?.salaryKey || ''} className={classes.inputTextbox} autoComplete="off"
                              onBlur={(event) => { handleBlurUpdate(event, selectedBorrowerIndex ?? index, 0, 'salaryKey') }} />
                          </Typography>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.Salarykey && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].Salarykey}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={4} className={classes.flexcontainer}>
                          <Typography variant="body2" className={classes.property}>Borrower Authorization</Typography>
                          <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-4}
                            className={classes.Filebutton}
                            startIcon={<CloudUploadIcon />}
                          >
                            {/* fileName[index] ? "" :  */}
                            {"Upload file"}
                            <input type="text" onClick={(event) => handleFileChange(event, selectedBorrowerIndex ?? index)} className={classes.VisuallyHiddenInput} autoComplete="off" />

                          </Button>
                          <Grid className={classes.fileNameMain} >
                            {fileName[selectedBorrowerIndex ?? index] && fileName[selectedBorrowerIndex ?? index].map((nameObj, objindex) => (
                              <Grid className={classes.fileNames}>
                                <Typography className={classes.selectedfilename} variant="body2" color="error" >
                                  {nameObj}

                                </Typography>
                                <Button
                                  onClick={(event) => handleCancelFile(event, selectedBorrowerIndex ?? index, objindex)}
                                  style={{ padding: 0, minWidth: 'auto' }}
                                  color="secondary"
                                  size="small"
                                >
                                  <CloseIcon style={{ fontSize: 17 }} />
                                </Button>
                              </Grid>
                            ))}
                          </Grid>
                          {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index]?.borrowerAuthorization && (
                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                              {errors?.borrowers[selectedBorrowerIndex != null ? selectedBorrowerIndex : index].borrowerAuthorization}
                            </Typography>
                          )}

                        </Grid>

                        <Grid item xs={12}>
                          <Typography className={classes.TypographyFlex}>
                            <Typography variant="body2" className={classes.property} style={{ margin: 0 }} >Employer Required?</Typography>
                            <Typography style={{ margin: 0 }} className={classes.value}>
                              {'No'}
                              <Switch
                                checked={borrower?.employerRequired || false}
                                onChange={(event) => handleChangeSwitch(event, selectedBorrowerIndex ?? index, 'employerRequired')}
                                inputProps={{ 'aria-label': 'ant design' }}
                                className={`${classes.switch}`}
                              />
                              {'Yes'}
                            </Typography>
                          </Typography>
                        </Grid>

                        {/* ---------------- Employment---------------- */}
                        {borrower?.employerRequired && borrower?.employment?.map((emp, empIndex) => (
                          <Card className={classes.EmpsubCard}>

                            <CardContent className={classes.EmploymentcardContent}>
                              <Typography component='h6' variant='h6' align='left' className={classes.Employmentheading}>
                                Employer Information
                              </Typography>
                              <Grid container spacing={2} key={empIndex} className="employment-entry" data-borrower-index={index} >
                                <Grid item xs={12} key={empIndex}>
                                  <Typography variant="body2" className={classes.property}>Current Employer</Typography>
                                  <Typography className={classes.value}>
                                    {'No'}
                                    <Switch
                                      checked={emp?.currentEmploymentIndicator}
                                      inputProps={{ 'aria-label': 'controlled' }}
                                      className={classes.switch}
                                    />
                                    {'Yes'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={4} key={empIndex}>
                                  <Typography variant="body2" className={classes.property}>Name <span className={classes.require} >*</span></Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" value={emp?.employerName} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                  </Typography>
                                  {!emp?.employerName && errors?.borrowers?.[index]?.employerName && (
                                    <Typography variant="body2" color="error" className={classes.errorMessage}>
                                      {errors.borrowers[index].employerName}
                                    </Typography>
                                  )}
                                </Grid>

                                <Grid item xs={4} >
                                  <Typography variant="body2" className={classes.property}>Code</Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" defaultValue={emp?.employerCode || ''} className={classes.inputTextbox} autoComplete="off"
                                      onBlur={(event) => { handleBlurUpdate(event, selectedBorrowerIndex ?? index, empIndex, 'employerCode') }} />
                                  </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography variant="body2" className={classes.property}>Division</Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" defaultValue={emp?.employerDivision || ''} className={classes.inputTextbox} autoComplete="off"
                                      onBlur={(event) => { handleBlurUpdate(event, selectedBorrowerIndex ?? index, empIndex, 'employerDivision') }} />
                                  </Typography>

                                </Grid>
                                <Grid item xs={4} key={index}>
                                  <Typography variant="body2" className={classes.property}>Employee Id <span className={classes.require} >*</span></Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" value={emp?.badgeOrEmployeeId} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                  </Typography>
                                  {!emp?.badgeOrEmployeeId && errors?.borrowers?.[index]?.badgeOrEmployeeId && (
                                    <Typography variant="body2" color="error" className={classes.errorMessage}>
                                      {errors.borrowers[index].badgeOrEmployeeId}
                                    </Typography>
                                  )}
                                </Grid>


                                <Grid item xs={4} key={index}>
                                  <Typography variant="body2" className={classes.property}>Start Date <span className={classes.require} >*</span></Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" value={emp?.employmentStartDate} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                  </Typography>
                                  {!emp?.employmentStartDate && errors?.borrowers?.[index]?.employmentStartDate && (
                                    <Typography variant="body2" color="error" className={classes.errorMessage}>
                                      {errors.borrowers[index].employmentStartDate}
                                    </Typography>
                                  )}
                                </Grid>
                                {!emp.currentEmploymentIndicator && (
                                  <Grid item xs={4}>
                                    <Typography variant="body2" className={classes.property}>End Date <span className={classes.require} >*</span></Typography>
                                    <Typography className={classes.value}>
                                      <input type="text" value={emp?.endDate} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                    </Typography>
                                    {!emp?.endDate && errors?.borrowers?.[index]?.endDate && (
                                      <Typography variant="body2" color="error" className={classes.errorMessage}>
                                        {errors.borrowers[index].endDate}
                                      </Typography>
                                    )}
                                  </Grid>

                                )}

                                <Grid item xs={4}>
                                  <Typography variant="body2" className={classes.property}>Phone <span className={classes.require} >*</span></Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" value={emp?.phoneNumber} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                  </Typography>
                                  {!emp?.phoneNumber && errors?.borrowers?.[index]?.phoneNumber && (
                                    <Typography variant="body2" color="error" className={classes.errorMessage}>
                                      {errors.borrowers[index].phoneNumber}
                                    </Typography>
                                  )}
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography variant="body2" className={classes.property}>Job Position <span className={classes.require} >*</span></Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" value={emp?.positionDescription} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                  </Typography>
                                  {!emp?.positionDescription && errors?.borrowers?.[index]?.positionDescription && (
                                    <Typography variant="body2" color="error" className={classes.errorMessage}>
                                      {errors.borrowers[index].positionDescription}
                                    </Typography>
                                  )}
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography variant="body2" className={classes.property}>Street Name <span className={classes.require} >*</span></Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" value={emp?.streetAddress} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                  </Typography>
                                  {!emp?.streetAddress && errors?.borrowers?.[index]?.streetAddress && (
                                    <Typography variant="body2" color="error" className={classes.errorMessage}>
                                      {errors.borrowers[index].streetAddress}
                                    </Typography>
                                  )}
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography variant="body2" className={classes.property}>City <span className={classes.require} >*</span></Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" value={emp?.addressCity} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                  </Typography>
                                  {!emp?.addressCity && errors?.borrowers?.[index]?.addressCity && (
                                    <Typography variant="body2" color="error" className={classes.errorMessage}>
                                      {errors.borrowers[index].addressCity}
                                    </Typography>
                                  )}
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography variant="body2" className={classes.property}>State <span className={classes.require} >*</span></Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" value={emp?.addressState} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                  </Typography>
                                  {!emp?.addressState && errors?.borrowers?.[index]?.addressState && (
                                    <Typography variant="body2" color="error" className={classes.errorMessage}>
                                      {errors.borrowers[index].addressState}
                                    </Typography>
                                  )}
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography variant="body2" className={classes.property}>Zip <span className={classes.require} >*</span></Typography>
                                  <Typography className={classes.value}>
                                    <input type="text" value={emp?.addressPostalCode} className={classes.inputTextbox} autoComplete="off" readonly disabled />
                                  </Typography>
                                  {!emp?.addressPostalCode && errors?.borrowers?.[index]?.addressPostalCode && (
                                    <Typography variant="body2" color="error" className={classes.errorMessage}>
                                      {errors.borrowers[index].addressPostalCode}
                                    </Typography>
                                  )}
                                </Grid>

                              </Grid>
                            </CardContent >
                          </Card>
                        ))}
                      </Grid>
                    ))}
                    {errors?.borrowers.length > 0 && errors?.borrowers[0] === 'At least one borrower is required.' && (
                      <Typography variant="body2" color="error" className={classes.errorMessage}>
                        {errors?.borrowers[0]}
                      </Typography>
                    )}
                    <Grid item xs={12}>
                    </Grid>
                  </CardContent>
                </Card>
                <Divider style={{ marginLeft: '16px', marginRight: '16px' }} />
              </Grid>
            </Grid>
          </Card>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button variant="contained" color="primary" className={classes.button} onClick={handleNext}>
                Submit
              </Button>
            </Box>
          </Grid>
        </div>
      </React.Fragment >
    );
  };

  // Interface definition for initialized component
  InitializedBorrowerInformation.propTypes = {
    loan: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
  };

  // Unitialized component rendering feedback spinner
  const UninitializedBorrowerInformation = () => {
    return (
      <React.Fragment>
        <Feedback message='Loading...' />
      </React.Fragment>
    );
  };

  // Handler to render the relative component - uninitialized or initialized
  const RenderBorrowerInformation = (props) => {
    // If origin loan data is present in state
    if (props.loan) {
      // Render initialized component
      return <InitializedBorrowerInformation loan={props.loan} host={props.host} onNext={props.onNext} />;
    } else {
      // // If origin loan data is empty/null - render uninitialized component
      return <UninitializedBorrowerInformation />;
      // return <UninitializedBorrowerInformation loan={props.loan} onNext={props.onNext} />;
    }
  };

  // Interface for conditional rendering component
  RenderBorrowerInformation.propTypes = {
    loan: PropTypes.object,
    onNext: PropTypes.func.isRequired,
  };

  return (
    <RenderBorrowerInformation loan={props.loan} host={props.host} onNext={props.onNext} />
  );
};

// Interface for Borrower Information component
BorrowerInformation.propTypes = {
  loan: PropTypes.object,
  onNext: PropTypes.func.isRequired,
};

export default BorrowerInformation;
